"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAutoCompleteResult = void 0;
const createSimpleFilter_1 = require("../core/createSimpleFilter");
function createAutoCompleteResult(result) {
    return Object.freeze({
        filter: result.filter && createSimpleFilter_1.createSimpleFilter(result.filter),
        key: result.key,
        matchedSubstrings: result.matchedSubstrings || [],
        value: result.value,
        relatedItem: result.relatedItem
    });
}
exports.createAutoCompleteResult = createAutoCompleteResult;
